const ContactMeMessage = ({title, message, icon}) => {
    return(
        <div className="group bg-slate-50 dark:bg-slate-900/50 border border-slate-200 dark:border-slate-700 rounded-xl p-6 hover:bg-slate-100 dark:hover:bg-slate-900 transition-all duration-300">
            <div className="flex items-start gap-4">
                <div className="p-3 bg-slate-100 dark:bg-slate-700 rounded-lg transition-all duration-300">
                    {icon}
                </div>
                <div className="flex-1">
                    <h3 className="font-bold text-lg text-slate-900 dark:text-white mb-2 transition-colors duration-300">{title}</h3>
                    <p className="text-slate-600 dark:text-slate-400 leading-relaxed font-light transition-colors duration-300">{message}</p>
                </div>
            </div>
        </div>
    )
}

const ContactMeMessageLink = ({title, message, icon}) => {
    return(
        <div className="group bg-slate-50 dark:bg-slate-900/50 border border-slate-200 dark:border-slate-700 rounded-xl p-6 hover:bg-slate-100 dark:hover:bg-slate-900 transition-all duration-300">
            <div className="flex items-start gap-4">
                <div className="p-3 bg-slate-100 dark:bg-slate-700 rounded-lg transition-all duration-300">
                    {icon}
                </div>
                <div className="flex-1">
                    <h3 className="font-bold text-lg text-slate-900 dark:text-white mb-2 transition-colors duration-300">{title}</h3>
                    <a 
                        href={message} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors duration-300 font-medium break-all"
                    >
                        {message}
                    </a>
                </div>
            </div>
        </div>
    )
}

const DetailContactMe = ({detailContact}) => {
    const emailIcon = (
        <svg className="w-6 h-6 text-slate-700 dark:text-slate-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
    );

    const phoneIcon = (
        <svg className="w-6 h-6 text-slate-700 dark:text-slate-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
        </svg>
    );

    const websiteIcon = (
        <svg className="w-6 h-6 text-slate-700 dark:text-slate-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9-9a9 9 0 00-9 9m0 0a9 9 0 009-9" />
        </svg>
    );

    return(
        <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-2xl p-8 shadow-sm transition-all duration-300">
            <div className="space-y-6">
                <div className="flex items-center gap-3">
                    <div className="w-1 h-8 bg-slate-900 dark:bg-slate-400 rounded-full"></div>
                    <h2 className="text-2xl font-bold text-slate-900 dark:text-white transition-colors duration-300">
                        Get In Touch
                    </h2>
                </div>

                <div className="mb-8">
                    <p className="text-slate-700 dark:text-slate-400 leading-relaxed text-lg font-light transition-colors duration-300">
                        I'm currently open to new freelance or remote opportunities. If you have an exciting project that you think I'd be a good fit for, I'd love to hear from you!
                    </p>
                </div>

                <div className="space-y-4">
                    {detailContact?.email && (
                        <ContactMeMessage 
                            title="Email" 
                            message={detailContact.email} 
                            icon={emailIcon}
                        />
                    )}
                    
                    {detailContact?.phone && (
                        <ContactMeMessage 
                            title="Phone" 
                            message={detailContact.phone} 
                            icon={phoneIcon}
                        />
                    )}
                    
                    {detailContact?.websiteUrl && (
                        <ContactMeMessageLink 
                            title="Website" 
                            message={detailContact.websiteUrl} 
                            icon={websiteIcon}
                        />
                    )}
                </div>

                {/* Additional contact methods */}
                <div className="pt-6 border-t border-slate-200 dark:border-slate-700">
                    <p className="text-sm text-slate-600 dark:text-slate-400 text-center font-light transition-colors duration-300">
                        Prefer social media? Find me on LinkedIn, GitHub, or Twitter
                    </p>
                </div>
            </div>
        </div>
    )
}
export default DetailContactMe;